import { useQuery } from '@tanstack/react-query';
import IPageSetting from '@legacy/apis/types/pageSettingAPI';
import { getFetch } from '@legacy/utils/fetcher';
import { parseBooleanFromString } from '@legacy/utils/boolean';

const PAGE_SETTINGS_URL_PATH = (pageIdentifier: string) =>
  `/api/v2/page-settings/${pageIdentifier}`;
export const PAGE_SETTINGS_MSW_STATUS_KEY = 'userFeatureAPI';

export const PAGE_SETTINGS_KEY = 'USER_FEATURE_SETTING';

export const useIsFeatureEnable = (
  pageIdentifierKey: string,
  userFeatureKey: string,
) => {
  const apiCall = (): Promise<IPageSetting> =>
    getFetch({
      path: PAGE_SETTINGS_URL_PATH(pageIdentifierKey),
      key: PAGE_SETTINGS_MSW_STATUS_KEY,
    });
  const { data, ...restProps } = useQuery({
    queryKey: [`${PAGE_SETTINGS_KEY}_${pageIdentifierKey}`],
    queryFn: apiCall,
  });
  return {
    isFeatureEnable: parseBooleanFromString(
      data?.properties?.[userFeatureKey] || '',
    ),
    ...restProps,
  };
};
